// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".documents--list[data-v-9bad47e2]{display:flex;flex-direction:column;gap:50px}.document--heading[data-v-9bad47e2]{display:flex;align-items:center;gap:30px;justify-content:flex-start;flex-direction:row}.document--heading h4[data-v-9bad47e2]{font-weight:900}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
